import { useCallback } from 'react';
import { useLocation, useSearch } from 'wouter';
import { consumeAppBackTarget, isAppShellLocation, safeAppReturnTo } from '@/lib/appNavigationHistory';

// Authenticated shells use known in-app history; direct opens fall back safely.
export function useBack(fallback: string): () => void {
  const [location, navigate] = useLocation();
  const search = useSearch();
  return useCallback(() => {
    const current = location.includes('?') ? location : location + (search ? `?${search}` : '');
    const query = current.includes('?') ? current.slice(current.indexOf('?')) : '';
    const explicit = safeAppReturnTo(query, current);
    if (!isAppShellLocation(current)) {
      if (explicit) navigate(explicit);
      else if (window.history.length > 1) window.history.back();
      else navigate(fallback);
      return;
    }
    navigate(explicit ?? consumeAppBackTarget(current) ?? fallback, { replace: true });
  }, [fallback, location, navigate, search]);
}
